import { useLocation } from 'react-router-dom';
import { getSigningFlowSteps } from '../utils';
/** Resolves the current signing-flow step from the route, omitting the down payment step when one isn't required. */
function useSigningFlowStep(downPaymentRequired) {
    const { pathname } = useLocation();
    if (downPaymentRequired === undefined)
        return null;
    const steps = getSigningFlowSteps(downPaymentRequired);
    const currentPath = pathname.replace(/\/$/, '');
    const index = steps.findIndex((step) => step.routes.some((route) => currentPath.endsWith(route)));
    if (index === -1)
        return null;
    return {
        totalSteps: steps.length,
        currentStep: index + 1,
        label: steps[index].label,
    };
}
export default useSigningFlowStep;
